import { SearchValidator } from "modules/manager/pages/professionals/utils";

export const PAGE_SIZE_SKELETON = 5;

export const cpfNameFilterType = ({ search, url }) => {
  if (!search?.trim()) return url;

  const searchTrimmed = search.trim();
  const searchHasOnlyLetters = /[a-zA-Z]/g.test(searchTrimmed);
  const searchWithOnlyNumbers = searchTrimmed.replace(/[^\d]/g, "");

  const isCPF =
    !searchHasOnlyLetters && SearchValidator.isCPF(searchWithOnlyNumbers);

  if (isCPF) {
    return (url += "&filter_type=cpf&value=" + searchWithOnlyNumbers);
  } else {
    return (url += "&filter_type=name&value=" + searchTrimmed);
  }
};
